import i18next from 'i18next';

i18next.init({
    fallbackLng: 'en',
    resources: {
        pl: {
            translations: require('./src/locales/pl/translations.json')
        },
        en: {
            translations: require('./src/locales/en/translations.json')
        }
    },
    ns: ['translations', 'cnk'],
    defaultNS: 'translations',
    returnObjects: true,
    redirect: false,
    generateDefaultLanguagePage: true,
    siteUrl: `https://digimuth.com`,
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
        escapeValue: false,
    },
    react: {
        useSuspense: true,
    },
});

i18next.languages = ['pl', 'en'];

export default i18next;
